import { ILesson } from '../booking-reviews-container/share-type'
import { IUser } from '../users-container/share-types'

export type IBooking = {
  id: number
  user: IUser
  lesson: ILesson
  entryTime: number
  isValid: boolean
  noShow: boolean
  completed: boolean
  notified: boolean
  cancelled: boolean
  cancelledBy: string | null
  createdAt: string
  updatedAt: string
  ref: string | null
  lateCancelled: boolean
  externalProviderId: string | null
  pending: boolean
  studioNoShow: boolean
  studioNoShowAt: string | null
  source: number | null
  studioConfirmedAttendance: boolean
  attendanceMarkedAt: string | null
  earlyVisit: boolean
  studioSignInTime: string | null
  studioSignOutTime: string | null
}

export enum BookingSource {
  'Unknown',
  'Website',
  'Mobile',
  'Mini-Program',
}
